import {AfterViewInit, Component, OnInit, Renderer2} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthTokenService} from '../../../shared/services/auth-token.service';
import {SurveyService} from '../surveys.service';
import {animation} from '../../../shared/animations/animations';
import {
  MasterSummaryPDModel,
  MasterSummaryQuestionModel,
  SurveyFilterUIModel,
  SurveyQuestionFilterRawModel,
  SurveyCutQuestionModel,
  SurveyVersionQuestionModel
} from '../../../models/survey/survey.model';
import {PreviousUrlService} from '../../../shared/services/previous-url.service';
import {environment} from '../../../../environments/environment';
import {PeopleModel} from '../../../models/people/people.model';
import {
  generateIncludeVersionCutLabel,
  generateNizPitanja,
  getDateFormat,
  isChoiceQuestion,
  isMaster,
  isMultipleOrSingleChoiceQuestion,
  setDefaultChart
} from '../../../shared/helpers/chart-helper';
import {
  IncludeSurveyModel,
  QuestionFilterDataModel,
  SummaryFilterModel,
  SurveyCutModelCore,
  SurveyLanguageModelCore,
  SurveyVersionModelCore
} from '../../../models/summary/summary.model';
import * as JSZip from 'jszip';
import {saveAs} from 'file-saver';
import {HideQuestionModel} from '../../../models/hide-question/hide-question.model';
import { SurveySettingQuestionModel, SurveySettingSmartAnalysisModel, SurveySettingVersionModel, SurveyUserSettingModel } from '../../../models/survey-user-setting/survey-user-setting.model';
import { FilterOption } from '../../../shared/constants/filter.constants';
import { SegmentModel } from '../../../models/segment/SegmentModel';
import { isNullOrUndefined } from 'util';

@Component({
  selector: 'app-master-summary',
  templateUrl: './master-summary.component.html',
  styleUrls: ['./master-summary.component.less'],
  animations: [animation]
})
export class MasterSummaryComponent implements OnInit, AfterViewInit {
  filter = false;
  people: Array<any>;
  column = 'gender';
  isDesc = false;
  surveyId: number;
  surveyTitle: string;
  loader = false;
  filePath: string;
  showUserPopup = false;
  showCutCreatePopup = false;
  user = new PeopleModel();
  surveyMasterSummaryPDModel: MasterSummaryPDModel;
  listSurveyQuestionRawFilter: SurveyQuestionFilterRawModel[] = [];
  isFilteringQuestion = false;
  listIncludeVersion: SurveyVersionModelCore[] = [];
  listSelectedSurveyHash: string[] = [];
  isApplyFilter = false;
  questionFilterLabel = 'Filters...';
  includeVersionLabel = 'Include versions';
  listSurveyFilterUI: SurveyFilterUIModel[] = [];
  filterOption = FilterOption.AND;
  includeSurvey: IncludeSurveyModel;
  listQuestionFilterData: QuestionFilterDataModel[] = [];
  summaryFilterModel: SummaryFilterModel;

  listSurveyCut: SurveyCutModelCore[] = [];
  listSurveyVersion: SurveyVersionModelCore[] = [];
  surveyLanguages: SurveyLanguageModelCore[] = [];
  listMissingQuestionId: number[];
  TranslatedAnswerQuestions: any;
  surveyVersionTranslated: string;

  showDropdownUnhide = false;

  totalMasterSummaryPeople = 0;
  cutId: number;
  cutTitle: string;
  segment: SegmentModel;
  originalFilterCut: string;
  originalSurveyVersionCut: string;
  isChangeCut = false;
  hideQuestions: HideQuestionModel[] = [];
  isSelectAllHideQuestion = false;

  WARNING_LOADER_TEXT = 'This might take a while…';
  isLoadSlower = false;
  disableUnhideButton = true;
  questionFilterTooltip = '';

  compareSurveyDataModel: MasterSummaryPDModel;
  compareIndex: any;
  surveyUserSetting: SurveyUserSettingModel;

  smartAnalysiscompareSurveyDataModel: MasterSummaryPDModel;

  activeTab = 1;
  init = false;

  showMenu = false;
  isShowExploreCompareChartsMode = false;

  constructor(public router: Router,
              private route: ActivatedRoute,
              private surveyService: SurveyService,
              private shareService: PreviousUrlService,
              private renderer: Renderer2
              )
  {
    this.route.params.subscribe();
    this.surveyId = parseInt(this.route.snapshot.paramMap.get('id'), 10);
    this.cutId = parseInt(this.route.snapshot.queryParamMap.get('cut'), 10);
    this.includeSurvey = new IncludeSurveyModel();
    this.route.data.subscribe(data => {
      this.surveyUserSetting = data.surveyUserSetting;
      if (!this.cutId) {
        this.listSurveyFilterUI = this.surveyUserSetting.settingsJSON.surveySettings.filters;
        if (this.surveyUserSetting.settingsJSON.surveySettings.isOrOperator) {
          this.filterOption = this.surveyUserSetting.settingsJSON.surveySettings.isOrOperator;
        }
        this.includeSurvey = this.surveyUserSetting.settingsJSON.surveySettings.includeSurvey;
        this.listSurveyVersion = this.includeSurvey.listSurveyVersion;
        this.listSurveyCut = this.includeSurvey.listSurveyCut;
      }
    });
  }

  ngOnInit() {
    this.filePath = environment.fileAnswerUrl;
    this.segment = new SegmentModel();
    if (this.cutId) {
      this.surveyService.getCut(this.cutId).subscribe(res => {
        res.listQuestionFilter.forEach(filterItem => {
          if ((filterItem.input === 'No response given' || filterItem.input === 'Response given') && !filterItem.operator) {
            filterItem.operator = 'Response given';
            if (filterItem.input === 'No response given') {
              filterItem.input = 'False';
            } else {
              filterItem.input = 'True';
            }
          }
        });
        this.originalFilterCut = JSON.stringify(res.listQuestionFilter ? res.listQuestionFilter : []);
        this.originalSurveyVersionCut = JSON.stringify(res.listVersion ? res.listVersion : []);
        this.isChangeCut = false;
        this.getListIncludeVersionCut(this.surveyId, res.listVersion, () => {
            this.applySurveyFilterUI(res.listQuestionFilter);
        });
        this.cutTitle = res.title;
        this.segment.id = this.cutId;
        this.segment.name = this.cutTitle;
        this.filterOption = res.isOrOperator;
        this.shareService.setSurveyTitle(res.title);
      });
    } else {
        this.surveyService.getTitleSurvey(this.surveyId).subscribe(res => {
            this.surveyTitle = res;
            this.shareService.setSurveyTitle(this.surveyTitle);
        });
        const listHash = this.includeSurvey.listSurveyVersion.map(o => o.hash);
        this.getListIncludeVersion(this.surveyId, listHash, () => {
            this.applySurveyFilterUI(this.listSurveyFilterUI);
        });
    }
    this.getListSurveyQuestionFilter();
    this.getListCutsByIdSurvey(this.surveyId);
    this.getHideQuestion(this.surveyId);
    this.getSurveyLanguage(this.surveyId);
  }

  ngAfterViewInit(): void {
      this.init = true;
  }

  getHideQuestion(surveyId: number) {
    this.surveyService
      .getHideQuestion(surveyId)
      .subscribe(res => {
        this.hideQuestions = res;
        this.hideQuestions = this.hideQuestions.sort((a, b) => a.questionId < b.questionId ? -1 : 1);
      }, err => {
      });
  }

  isHideQuestion(questionId: number) {
    return this.hideQuestions.map(x => x.questionId).includes(questionId);
  }

  isMisingQuestion(questionId: number, parentQuestionId: number) {
    return this.listMissingQuestionId ? this.listMissingQuestionId.includes(questionId) || this.listMissingQuestionId.includes(parentQuestionId) : false;
  }

  getListIncludeVersion(id: number, listVersionHash?: string[], callback?: () => any) {
    const cb = callback || function () {
    };
    this.surveyService.getListIncludeVersion(id).toPromise().then(
      res => {
        this.listSurveyVersion = res.versions;
        if (listVersionHash && listVersionHash.length > 0) {
          this.listSurveyVersion.forEach(x => listVersionHash.indexOf(x.hash) > 0 ? x.isSelected = true : x.isSelected = false);
        } else {
          if (this.surveyUserSetting.id === 0) {
            this.listSurveyVersion.forEach(x => x.isSelected = true);
          } else {
            this.listSurveyVersion.forEach(x => x.isSelected = false);
          }
        }

        if (this.surveyUserSetting.id === 0) {
          this.includeSurvey = new IncludeSurveyModel();
          this.includeSurvey.compare = false;
          this.includeSurvey.allVersionSelected = listVersionHash ? false : true;
          this.listIncludeVersion = res.versions;
          this.includeSurvey.listSurveyVersion = this.listIncludeVersion;
          this.listSurveyVersion = this.includeSurvey.listSurveyVersion;
          this.surveyUserSetting.settingsJSON.surveySettings.includeSurvey = this.includeSurvey;
        } else {
          this.listIncludeVersion = this.surveyUserSetting.settingsJSON.surveySettings.includeSurvey.listSurveyVersion;
        }

        this.listSelectedSurveyHash = this.listIncludeVersion.map(x => x.hash);
        this.summaryFilterModel = new SummaryFilterModel(this.includeSurvey, []);
        this.generateIncludeVersionLabel();
        this.setListMissingQuestionId();
        cb();
      }, err => {
      }
    );
  }

  getListIncludeVersionCut(id: number, listVersionHash?: string[], callback?: () => any) {
    const cb = callback || function () {
    };
    this.surveyService.getListIncludeVersion(id).toPromise().then(
      res => {
        this.listSurveyVersion = res.versions;
        if (listVersionHash && listVersionHash.length > 0) {
          this.listSurveyVersion.forEach(x => listVersionHash.indexOf(x.hash) > 0 ? x.isSelected = true : x.isSelected = false);
        } else {
          this.listSurveyVersion.forEach(x => x.isSelected = true);
        }
        this.includeSurvey = new IncludeSurveyModel();
        this.includeSurvey.compare = false;
        this.includeSurvey.allVersionSelected = listVersionHash ? false : true;
        this.listIncludeVersion = res.versions;
        if (listVersionHash && listVersionHash.length > 0) {
          this.listIncludeVersion = this.listIncludeVersion.filter(x => listVersionHash.indexOf(x.hash) >= 0 || (listVersionHash[0] == (null) && x.hash == null));
        }
        this.listIncludeVersion.forEach(x => x.isSelected = true);
        this.includeSurvey.listSurveyVersion = this.listIncludeVersion;
        this.listSelectedSurveyHash = this.listIncludeVersion.map(x => x.hash);
        this.summaryFilterModel = new SummaryFilterModel(this.includeSurvey, []);
        this.generateIncludeVersionLabel();
        this.setListMissingQuestionId();
        cb();
      }, err => {
      }
    );
  }

  openUserPopup(user) {
    this.user = user;
    this.showUserPopup = true;
  }

  sort(user) {
    this.isDesc = !this.isDesc;
    this.column = user;
    const direction = this.isDesc ? 1 : -1;

    for (let i = 0; i < this.surveyMasterSummaryPDModel.listQuestionModel.length; i++) {
      this.surveyMasterSummaryPDModel.listQuestionModel[i].listAnswerModel.sort(function (a, b) {
        if (a[user] < b[user]) {
          return -1 * direction;
        } else if (a[user] > b[user]) {
          return 1 * direction;
        } else {
          return 0;
        }
      });
    }
  }

  print(): void {
    let printContents, popupWin;
    printContents = document.getElementById('print-section').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <title>Survey</title>
          <style>
          </style>
        </head>
    <body onload="window.print();window.close()">${printContents}</body>
      </html>`
    );
    popupWin.document.close();
  }

  getMasterSummaryPDModel() {
    this.loader = true;
    this.surveyService.getMasterSummaryPDModel(this.surveyId, this.filterOption)
      .subscribe((res) => {
          this.surveyMasterSummaryPDModel = res;
          for (const item of this.surveyMasterSummaryPDModel.listQuestionModel) {
            item.haveAnswered = 'Have Answered';
            item.haveNotAnswered = 'Have Not Answered';
            item.nizPitanja = generateNizPitanja(item);
            setDefaultChart(item.defaultChart.chart, item);
          }
          this.copyOriginalQuestions(this.surveyMasterSummaryPDModel);
          this.loader = false;
        },
        (err) => {
          this.loader = false;
        });
  }

  createSummaryDataTableCsv() {
    let data = '';

    for (const item of this.surveyMasterSummaryPDModel.listQuestionModel) {

      data += (item.questionName ? item.questionName
        .replace(/,/g, ' ')
        .replace(/[\r\n]/g, ' ')
        .replace(/[\n]/g, ' ')
        .replace(/[\r]/g, ' ') : '');
      if (item.listAnswerModel.length > 0) {
        data += ','.repeat(item.listAnswerModel.length);
      } else {
        data += ','.repeat(2);
      }
    }

    data += '\r\n';

    for (const item of this.surveyMasterSummaryPDModel.listQuestionModel) {
      item.haveAnswered = 'Have Answered';
      item.haveNotAnswered = 'Have Not Answered';
      if (item.listAnswerModel.length > 0) {
        for (const x of item.listAnswerModel) {
          data += (x ? x.answerName ? x.answerName
            .replace(/,/g, ' ')
            .replace(/[\r\n]/g, ' ')
            .replace(/[\n]/g, ' ')
            .replace(/[\r]/g, ' ') : '' : '') + ',';
        }
      } else {
        data += item.haveAnswered + ',';
        data += item.haveNotAnswered + ',';
      }
    }

    data += '\r\n';

    for (const item of this.surveyMasterSummaryPDModel.listQuestionModel) {
      if (item.listAnswerModel.length > 0) {
        for (const x of item.listAnswerModel) {
          data += x.answerCount + ',';
        }
      } else {
        data += item.answeredCount + ',';
        data += item.nonAnsweredCount + ',';
      }
    }


    data += '\r\n';

    for (const item of this.surveyMasterSummaryPDModel.listQuestionModel) {
      if (item.listAnswerModel.length > 0) {
        for (const x of item.listAnswerModel) {
          data += x.answerPercentage + '%' + ',';
        }
      } else {
        data += item.answeredPercentage + '%' + ',';
        data += item.nonAnsweredPercentage + '%' + ',';

      }
    }
    return Promise.resolve(data);
  }

  createRawDataCSV() {
    return new Promise((resolve, reject) => {
      const summaryFilterModel = new SummaryFilterModel(this.includeSurvey, this.listQuestionFilterData);
      this.surveyService.getAllMasterSummaryForPeopleByQuestionFilter(this.surveyId, summaryFilterModel)
        .toPromise()
        .then((csvRecords: string[]) => {
          let rawData = '';
          for (const record of csvRecords) {
            rawData += record.replace(/[\r\n]/g, ' ')
              .replace(/[\n]/g, ' ')
              .replace(/[\r]/g, ' ') + '\r\n';
          }
          resolve(rawData);
        }, _ => {
          resolve('');
        });
    });
  }

  getListSurveyQuestionFilter() {
    this.surveyService.getListSurveyQuestionFilter(this.surveyId)
      .subscribe((response) => {
          this.listSurveyQuestionRawFilter = response;
        },
        (error) => {
        });
  }

  onIncludeSurveyChoice(includeSurvey: any) {
    if (!includeSurvey.compare) {
      this.isShowExploreCompareChartsMode = false;
    }
    this.activeTab = 1;
    this.surveyService.removeSmartAnalysisWithoutAnalysisAllResults();
    if (!this.cutId) {
        this.surveyUserSetting.settingsJSON.surveySettings.includeSurvey = includeSurvey;
        this.surveyService.updateSurveyUserSetting(this.surveyUserSetting).subscribe(res => {
        this.surveyUserSetting = res;
        this.applyIncludeSurveyChoice(includeSurvey);
        }, err => {
        });
    } else {
        this.applyIncludeSurveyChoice(includeSurvey);
    }
  }

  applyIncludeSurveyChoice(includeSurvey: any) {
    if (includeSurvey.compare && includeSurvey.isOverChooseValid) {
      this.isLoadSlower = true;
    }
    this.isChangeCut = this.isChangedCut(this.listSurveyFilterUI, includeSurvey.listSurveyVersion);
    this.includeSurvey = includeSurvey;
    this.surveyUserSetting.settingsJSON.surveySettings.includeSurvey = this.includeSurvey;
    this.generateIncludeVersionLabel();
    this.filterAndIncludeSurvey(includeSurvey, this.listQuestionFilterData);
    this.setListMissingQuestionId();
  }

  generateIncludeVersionLabel() {
    this.includeVersionLabel = generateIncludeVersionCutLabel(this.includeSurvey.compare,
      this.includeSurvey.allResponsesSelected,
      this.includeSurvey.listSurveyVersion,
      this.includeSurvey.listSurveyCut);
  }

  onQuestionFilterFinished(filter) {
    this.filterOption = filter.isOrOperator;
    this.activeTab = 1;
    this.surveyService.removeSmartAnalysisWithoutAnalysisAllResults();
    if (!this.cutId) {
        this.surveyUserSetting.settingsJSON.surveySettings.filters = filter.listSurveyFilterUI;
        this.surveyUserSetting.settingsJSON.surveySettings.isOrOperator = filter.isOrOperator;
        this.surveyService.updateSurveyUserSetting(this.surveyUserSetting).subscribe(res => {
        this.surveyUserSetting = res;
        this.applySurveyFilterUI(filter.listSurveyFilterUI);
        }, err => {
        });
    } else {
        this.applySurveyFilterUI(filter.listSurveyFilterUI);
    }
  }

  onSaveSegment() {
    this.getListCutsByIdSurvey(this.surveyId);
  }

  applySurveyFilterUI(listSurveyFilterUI) {
    this.listSurveyFilterUI = listSurveyFilterUI ? listSurveyFilterUI.filter(s => s.isChecked && s.question) : [];
    this.isChangeCut = this.isChangedCut(this.listSurveyFilterUI, this.includeSurvey.listSurveyVersion);
    const listQuestionFilterData: QuestionFilterDataModel[] = [];
    if (this.listSurveyFilterUI.length) {
      const questions = this.listSurveyFilterUI.map(x => x.question.question);
      this.questionFilterTooltip = questions.join('\n');
    } else {
      this.questionFilterTooltip = '';
    }

    this.listSurveyFilterUI.forEach(s => {
      const questionFilterData = new QuestionFilterDataModel();
      questionFilterData.id = s.question.id;
      questionFilterData.answerType = s.question.answerType;
      questionFilterData.isOrOpr = s.isOrOpr;
      if (isChoiceQuestion(questionFilterData.answerType)) {
        questionFilterData.listAnswerId = s.listAnswerId;
        if (isMultipleOrSingleChoiceQuestion(questionFilterData.answerType)) {
          questionFilterData.operator = s.operator;
          if (!questionFilterData.operator) {
            questionFilterData.operator = '=';
          }
        }
      } else {
        questionFilterData.operator = s.operator;
        if ('Date' === questionFilterData.answerType) {
          questionFilterData.input = getDateFormat(s.input);
        } else if ('Text' === questionFilterData.answerType) {
          questionFilterData.operator = s.operator;
          questionFilterData.input = s.input;
        } else {
          questionFilterData.input = s.input;
        }
      }
      listQuestionFilterData.push(questionFilterData);
    });

    this.isFilteringQuestion = false;
    this.renderer.removeClass(document.body, 'modal-open');
    this.loader = true;
    if (listQuestionFilterData.length) {
      this.isApplyFilter = true;
      this.questionFilterLabel = 'Filters (' + listQuestionFilterData.length + ')';
    } else {
      this.isApplyFilter = false;
      this.questionFilterLabel = 'Filters...';
    }

    this.listQuestionFilterData = listQuestionFilterData;
    this.filterAndIncludeSurvey(this.includeSurvey, listQuestionFilterData);
  }

  filterAndIncludeSurvey(includeSurvey: IncludeSurveyModel, listQuestionFilterData: QuestionFilterDataModel[]) {
    this.summaryFilterModel = new SummaryFilterModel(includeSurvey, listQuestionFilterData);
    this.summaryFilterModel.isOrOperator = this.filterOption;
    this.loader = true;
    this.surveyService.getMasterSummaryPDModelByQuestionFilter(this.surveyId, this.summaryFilterModel)
      .subscribe(res => {
        let data = res;
        window.scrollTo(0, 0);
        for (const item of data.listQuestionModel) {
          item.haveAnswered = 'Have Answered';
          item.haveNotAnswered = 'Have Not Answered';
          const nizPitanja = Object.assign([], item.nizPitanja);
          item.nizPitanja = generateNizPitanja(item);
          if ((item.answerType === 'Text' && item.defaultChart.chart === 'Bar')) {
              if (nizPitanja[0].answerName !== item.nizPitanja[0].answerName) {
                item.nizPitanja = [item.nizPitanja[1], item.nizPitanja[0]];
              }
          }
          setDefaultChart(item.defaultChart.chart, item);
        }
        if (includeSurvey && includeSurvey.compare) {
          data.listSurveyVersionQuestion.sort((a, b) => a.surveyName.toLowerCase() > b.surveyName.toLowerCase() ? 1 : -1);
          data.listSurveyVersionQuestion.sort((a, b) => a.surveyName.includes('MASTER') && !b.surveyName.includes('MASTER') ? -1 : 1);
          data.listSurveyCutQuestion.sort((a, b) => a.surveyName.toLowerCase() > b.surveyName.toLowerCase() ? 1 : -1);
          this.compareIndex = {value: 3};
          this.surveyMasterSummaryPDModel = new MasterSummaryPDModel();
          if (data.listSurveyVersionQuestion) {
            for (const surveyVersion of data.listSurveyVersionQuestion) {
              for (const item of surveyVersion.listQuestionModel) {
                item.haveAnswered = 'Have Answered';
                item.haveNotAnswered = 'Have Not Answered';
                const nizPitanja = Object.assign([], item.nizPitanja);
                item.nizPitanja = generateNizPitanja(item);
                if ((item.answerType === 'Text' && item.defaultChart.chart === 'Bar')) {
                    if (nizPitanja[0].answerName !== item.nizPitanja[0].answerName) {
                      item.nizPitanja = [item.nizPitanja[1], item.nizPitanja[0]];
                    }
                }
                setDefaultChart(item.defaultChart.chart, item);
              }
            }
          }
          if (data.listSurveyCutQuestion && data.listSurveyCutQuestion.length) {
            for (const surveyCut of data.listSurveyCutQuestion) {
              for (const item of surveyCut.listQuestionModel) {
                item.haveAnswered = 'Have Answered';
                item.haveNotAnswered = 'Have Not Answered';
                const nizPitanja = Object.assign([], item.nizPitanja);
                item.nizPitanja = generateNizPitanja(item);
                if ((item.answerType === 'Text' && item.defaultChart.chart === 'Bar')) {
                    if (nizPitanja[0].answerName !== item.nizPitanja[0].answerName) {
                      item.nizPitanja = [item.nizPitanja[1], item.nizPitanja[0]];
                    }
                }
                setDefaultChart(item.defaultChart.chart, item);
              }
            }
          }

          this.smartAnalysiscompareSurveyDataModel = JSON.parse(JSON.stringify(data));

          this.surveyMasterSummaryPDModel.listQuestionModel = data.listQuestionModel;
          this.surveyMasterSummaryPDModel.listSurveyVersionQuestion = [];
          this.surveyMasterSummaryPDModel.listSurveyCutQuestion = [];
          if (!includeSurvey.allResponsesSelected) {
            if (data.listSurveyVersionQuestion && data.listSurveyVersionQuestion.length > 0) {
              this.surveyMasterSummaryPDModel.listSurveyVersionQuestion.push(data.listSurveyVersionQuestion[0]);
              data.listSurveyVersionQuestion.splice(0, 1);
            } else {
              this.surveyMasterSummaryPDModel.listSurveyCutQuestion.push(data.listSurveyCutQuestion[0]);
              data.listSurveyCutQuestion.splice(0, 1);
            }
          }
          this.compareSurveyDataModel = data;
          this.setMissingQuestionCompareMode(this.compareSurveyDataModel);
          this.compareSurveyDataModel.listSurveyVersionQuestion.forEach(item => {
            // let i = Object.assign({}, item);
            // i.listQuestionModel = i.listQuestionModel.slice(0, 3);
            this.surveyMasterSummaryPDModel.listSurveyVersionQuestion.push(item);
          });
          this.compareSurveyDataModel.listSurveyCutQuestion.forEach(item => {
            // let i = Object.assign({}, item);
            // i.listQuestionModel = i.listQuestionModel.slice(0, 3);
            this.surveyMasterSummaryPDModel.listSurveyCutQuestion.push(item);
          });
          this.copyOriginalQuestions(this.compareSurveyDataModel);
          this.copyOriginalQuestions(this.surveyMasterSummaryPDModel);
        } else {
          this.surveyMasterSummaryPDModel = data;
          this.copyOriginalQuestions(this.surveyMasterSummaryPDModel);
        }
        this.setVersionNameSelected();
        this.loader = false;
        this.isLoadSlower = false;
      }, err => {
        this.loader = false;
        this.isLoadSlower = false;
      });
  }

  onToggleQuestionFilter(isOpen: boolean) {
    this.isFilteringQuestion = !isOpen;
    if (!isOpen) {
      this.renderer.addClass(document.body, 'modal-open');
    } else {
      this.renderer.removeClass(document.body, 'modal-open');
    }
  }

  onQuestionFilterCancelled(close: boolean) {
    this.isFilteringQuestion = false;
    this.renderer.removeClass(document.body, 'modal-open');
  }

  isIncludeVersion(): boolean {
    return this.includeSurvey ? !this.includeSurvey.compare : false;
  }

  onClickOutsideBtn(event: any, item: string) {
    if (event && event['value'] === true) {
      if (item === 'unhide') {
        const listExceptionalId: string[] = [
          'unhide-label-id'
        ];
        if (!listExceptionalId.includes(event.target.id)) {
          this.cancelUnhide();
        }
      }
    }
  }

  onSaveAsCut(event) {
    this.showCutCreatePopup = false;
    this.surveyService.saveCut({
      surveyId: this.surveyId,
      title: event,
      listQuestionFilter: this.listSurveyFilterUI,
      isOrOperator: this.filterOption,
      listVersion: this.includeSurvey.listSurveyVersion.map(item => item.hash)
    }).subscribe(res => {
      this.getListCutsByIdSurvey(this.surveyId);
      this.surveyService.resetSmartAnalysisResults();
    }, err => {

    });
  }

  onSaveCut() {
    if (this.cutId) {
      this.surveyService.updateCut(this.cutId, {
        listQuestionFilter: this.listSurveyFilterUI,
        isOrOperator: this.filterOption,
        listVersion: this.includeSurvey.listSurveyVersion.map(item => item.hash)
      }).subscribe(res => {
        this.originalFilterCut = JSON.stringify(this.listSurveyFilterUI);
        this.originalSurveyVersionCut = JSON.stringify(this.includeSurvey.listSurveyVersion.map(item => item.hash));
        this.isChangeCut = false;
        this.getListCutsByIdSurvey(this.surveyId);
        this.surveyService.resetSmartAnalysisResults();
      }, err => {
      });
    }
  }

  navigateToCut() {
    this.router.navigate(['/surveys/' + this.surveyId + '/' + 'cuts']);
  }

  navigateToSurvey() {
    this.router.navigate(['/surveys/master-summary/' + this.surveyId]).then(_ => {
        window.location.reload();
    });
  }

  changeSurveyLanguage(id: number) {
    this.surveyService.resetSmartAnalysisResults();
    this.surveyUserSetting.settingsJSON.surveySettings.languageId = id;
    this.surveyService.updateSurveyUserSetting(this.surveyUserSetting).subscribe(res => {
      this.surveyUserSetting = res;
      this.reloadData();
    }, err => {

    });
  }

  getListCutsByIdSurvey(idSurvey: number) {
    this.surveyService.getCuts(idSurvey).subscribe(res => {
      this.listSurveyCut = res.listCut;
      this.listSurveyCut.sort((a, b) => a.title.toLowerCase() > b.title.toLowerCase() ? 1 : -1);
      this.listSurveyCut.forEach(cut => cut.isSelected = false);
    }, err => {

    });
  }

  downloadCSVZip() {
    this.loader = true;
    const fileZipName = this.generateFileZipName();
    this.createSummaryDataTableCsv().then(summaryDataTable => {
      this.createRawDataCSV().then((rawData: any) => {
        this.loader = false;
        const zip = new JSZip();
        const fileNameSummaryDataTable = 'SummaryDataTable.csv';
        zip.file(`${fileNameSummaryDataTable}`, summaryDataTable);
        const fileNameRawData = 'RawData.csv';
        zip.file(`${fileNameRawData}`, rawData);
        zip
          .generateAsync(
            {type: 'blob'})
          .then(blob => saveAs(blob, `${fileZipName}`));
      });
    });
  }

  generateFileZipName() {
    const titleName = this.cutId ? this.cutTitle : this.surveyTitle;
    return titleName ? titleName.replace(/[/\\?%*:|"<>]/g, '-').concat('.zip') : 'csv.zip';
  }

  onHideQuestion(id: number) {
    this.loader = true;
    this.surveyService
      .saveHideQuestion({
        surveyId: this.surveyId,
        questionId: id
      })
      .subscribe(res => {
        this.loader = false;
        this.getHideQuestion(this.surveyId);
        this.surveyService.removeSmartAnalysisResults();
        this.activeTab = 1;
      }, err => {
        this.loader = false;
      });
  }

  unhide() {
    this.showDropdownUnhide = false;
    this.isSelectAllHideQuestion = false;
    this.disableUnhideButton = true;
    const ids = this.hideQuestions.filter(x => x.isUnhide).map(x => x.id);
    this.loader = true;
    this.surveyService
      .unhideQuestion(ids)
      .subscribe(res => {
        this.loader = false;
        this.getHideQuestion(this.surveyId);
        this.surveyService.removeSmartAnalysisResults();
        this.activeTab = 1;
      }, err => {
        this.loader = false;
      });
  }

  cancelUnhide() {
    this.showDropdownUnhide = false;
    this.isSelectAllHideQuestion = false;
    this.hideQuestions.forEach(x => x.isUnhide = false);
    this.disableUnhideButton = true;
  }

  onSelectAllHideQuestion() {
    this.hideQuestions.forEach(x => x.isUnhide = this.isSelectAllHideQuestion);
    this.disableUnhideButton = this.hideQuestions.filter(x => x.isUnhide).length === 0;
  }

  onSelectHideQuestion() {
    this.disableUnhideButton = this.hideQuestions.filter(x => x.isUnhide).length === 0;
  }

  private isChangedCut(filterQuestions: any, versionFilters: any) {
    return this.originalSurveyVersionCut !== JSON.stringify(versionFilters.map(item => item.hash))
           || this.originalFilterCut !== JSON.stringify(filterQuestions);
  }

  private setListMissingQuestionId() {
    if (this.includeSurvey.listSurveyVersion.find(item => item.hash === null)) {
      this.listMissingQuestionId = [];
      return;
    } else {
      if ((this.includeSurvey.allResponsesSelected && this.includeSurvey.compare)
       || (this.includeSurvey.allVersionSelected && !this.includeSurvey.compare)) {
        this.listMissingQuestionId = [];
        return;
      }
    }
    let arr = this.includeSurvey.listSurveyVersion.filter(item => item.hash !== null).map(item => item.missingQuestionIds);
    if (arr && arr.length) {
      let missingQuestionId = arr[0];
      for(var i=1; i < (arr ? arr.length : 0); i++){
        missingQuestionId = missingQuestionId.filter(x => arr[i].includes(x));
      }
      this.listMissingQuestionId = missingQuestionId;
    } else {
      this.listMissingQuestionId = [];
    }
  }

  private setMissingQuestionCompareMode(data: MasterSummaryPDModel): void {
    this.setMissingQuestionIdVersion(data.listSurveyVersionQuestion);
    this.setMissingQuestionIdCut(data.listSurveyCutQuestion);
  }

  private setMissingQuestionIdVersion(listSurveyVersion: SurveyVersionQuestionModel[]) {
    if (listSurveyVersion && this.includeSurvey) {
      listSurveyVersion.forEach(compareVersion => {
        var surveyVersion = this.includeSurvey.listSurveyVersion.find(missinQuestionVersion => missinQuestionVersion.surveyName === compareVersion.surveyName);
        compareVersion.listMissingQuestionId = surveyVersion ? surveyVersion.missingQuestionIds : null;
      })
    }
  }

  private setMissingQuestionIdCut(listCutQuestion: SurveyCutQuestionModel[]) {
    if (listCutQuestion && this.listSurveyCut) {
      listCutQuestion.forEach(compareCut => {
        var cut = this.includeSurvey.listSurveyCut.find(missinQuestion => missinQuestion.title === compareCut.surveyName);
        compareCut.listMissingQuestionId = cut ? cut.missingQuestionIds : null;
      })
    }
  }

  private copyOriginalQuestions(modelLoad: MasterSummaryPDModel){
    if(modelLoad){
      if(modelLoad.listQuestionModel && modelLoad.listQuestionModel.length > 0){
        let i:number;
        for(i=0;i<modelLoad.listQuestionModel.length;i++){
          modelLoad.listQuestionModel[i].copyListAnswerModel = Object.assign([],modelLoad.listQuestionModel[i].listAnswerModel);
          modelLoad.listQuestionModel[i].copyNizPitanja = Object.assign([],modelLoad.listQuestionModel[i].nizPitanja);
        }
      }
      if(modelLoad.listSurveyVersionQuestion && modelLoad.listSurveyVersionQuestion.length > 0){
        let i:number;
        for(i=0;i<modelLoad.listSurveyVersionQuestion.length;i++){
          if(modelLoad.listSurveyVersionQuestion[i] && modelLoad.listSurveyVersionQuestion[i].listQuestionModel && modelLoad.listSurveyVersionQuestion[i].listQuestionModel.length > 0){
            let j:number;
            for(j=0;j<modelLoad.listSurveyVersionQuestion[i].listQuestionModel.length;j++){
              modelLoad.listSurveyVersionQuestion[i].listQuestionModel[j].copyListAnswerModel = Object.assign([],modelLoad.listSurveyVersionQuestion[i].listQuestionModel[j].listAnswerModel);
              modelLoad.listSurveyVersionQuestion[i].listQuestionModel[j].copyNizPitanja = Object.assign([],modelLoad.listSurveyVersionQuestion[i].listQuestionModel[j].nizPitanja);
            }
          }
        }
      }
      if(modelLoad.listSurveyCutQuestion && modelLoad.listSurveyCutQuestion.length > 0){
        let i:number;
        for(i=0;i<modelLoad.listSurveyCutQuestion.length;i++){
          if(modelLoad.listSurveyCutQuestion[i] && modelLoad.listSurveyCutQuestion[i].listQuestionModel && modelLoad.listSurveyCutQuestion[i].listQuestionModel.length > 0){
            let j:number;
            for(j=0;j<modelLoad.listSurveyCutQuestion[i].listQuestionModel.length;j++){
              modelLoad.listSurveyCutQuestion[i].listQuestionModel[j].copyListAnswerModel = Object.assign([],modelLoad.listSurveyCutQuestion[i].listQuestionModel[j].listAnswerModel);
              modelLoad.listSurveyCutQuestion[i].listQuestionModel[j].copyNizPitanja = Object.assign([],modelLoad.listSurveyCutQuestion[i].listQuestionModel[j].nizPitanja);
            }
          }
        }
      }
    }
  }

  setVersionNameSelected(){
    let surveyTranslateSelected: SurveyVersionQuestionModel;
    let surveyMaster =  this.surveyMasterSummaryPDModel.listSurveyVersionQuestion.find(s=> isMaster(s.surveyName));
    if(this.TranslatedAnswerQuestions && this.surveyVersionTranslated)  {
      surveyTranslateSelected =  this.surveyMasterSummaryPDModel.listSurveyVersionQuestion.find(s=> s.surveyName === this.surveyVersionTranslated);
      if (surveyTranslateSelected) {
        this.summaryFilterModel.version = surveyTranslateSelected.surveyName;
        this.translateSurvey(this.TranslatedAnswerQuestions);
      } else {
        if (surveyMaster) {
          this.summaryFilterModel.version = surveyMaster.surveyName;
        } else if(this.surveyMasterSummaryPDModel.listSurveyVersionQuestion.length > 0) {
          this.summaryFilterModel.version = this.surveyMasterSummaryPDModel.listSurveyVersionQuestion[0].surveyName;
        }
      }
    } else if (surveyMaster) {
      this.summaryFilterModel.version = surveyMaster.surveyName;
    }

  }

  translateAndIncludeSurvey(includeSurvey: IncludeSurveyModel, listQuestionFilterData: QuestionFilterDataModel[], hash: string, version: string,) {

      this.summaryFilterModel = new SummaryFilterModel(includeSurvey, listQuestionFilterData, hash, this.surveyVersionTranslated, this.surveyId);

    this.loader = true;
    this.surveyService.getTranslateAnswerQuestions(this.summaryFilterModel)
    .subscribe(res => {
      this.TranslatedAnswerQuestions = res;
      this.translateSurvey(res);
      this.summaryFilterModel.version = version;
      this.loader = false;
    }, err => {
      this.loader = false;
      this.isLoadSlower = false;
    });

  }

  translateSurvey(dataTranslated){
    this.surveyMasterSummaryPDModel.listQuestionModel.forEach(question =>{
      this.translateQuestionAnswer(question, dataTranslated);
    });

    this.surveyMasterSummaryPDModel.listSurveyCutQuestion.forEach(survey =>{
      survey.listQuestionModel.forEach(question => {
        this.translateQuestionAnswer(question, dataTranslated);
      });
    });

    this.surveyMasterSummaryPDModel.listSurveyVersionQuestion.forEach(survey =>{
      survey.listQuestionModel.forEach(question => {
        this.translateQuestionAnswer(question, dataTranslated);
      });
    });

    this.compareSurveyDataModel.listQuestionModel.forEach(question =>{
      this.translateQuestionAnswer(question, dataTranslated);
    });

    this.compareSurveyDataModel.listSurveyCutQuestion.forEach(survey =>{
      survey.listQuestionModel.forEach(question => {
        this.translateQuestionAnswer(question, dataTranslated);
      });
    });

    this.compareSurveyDataModel.listSurveyVersionQuestion.forEach(survey =>{
      survey.listQuestionModel.forEach(question => {
        this.translateQuestionAnswer(question, dataTranslated);
      });
    });
  }

  private translateQuestionAnswer(question: MasterSummaryQuestionModel, dataTranslated: any){
    let questionTranslated
    if (question) {

      if (question.parentQuestionId > 0) {
        questionTranslated = dataTranslated.surveyQuestionTranslate.find(q=>q.surveyQuestionId === question.parentQuestionId);
        question.groupQuestionName = questionTranslated ? questionTranslated.text : question.groupQuestionName;
      } else {
        questionTranslated = dataTranslated.surveyQuestionTranslate.find(q=>q.surveyQuestionId === question.id);
        question.questionName = questionTranslated ? questionTranslated.text : question.questionName;
      }

      question.listAnswerModel.forEach(answer => {
        let answerTranslated = dataTranslated.surveyAnswerTranslate.find(q=>q.surveyQuestionAnswerId === answer.id);
        if (answerTranslated) {
          answer.answerName = answerTranslated.text;
        }
      });
    }
  }

  onTranslate(nameVersionSelected){
     let versionSelected: SurveyVersionModelCore = this.listIncludeVersion.find(v=> v.surveyName === nameVersionSelected );
     if (versionSelected) {
      this.surveyVersionTranslated = versionSelected.surveyName;
     } else {
      let versionMaster: SurveyVersionModelCore = this.listIncludeVersion.find(v=> isMaster(v.surveyName) );
      if (versionMaster) {
        this.surveyVersionTranslated = versionMaster.surveyName;
      } else if(this.listIncludeVersion.length > 0) {
        this.surveyVersionTranslated = this.listIncludeVersion[0].surveyName;
      }
     }

     if (this.includeSurvey.compare) {
       this.isLoadSlower = true;
     }
     if (versionSelected) {
       this.translateAndIncludeSurvey(this.includeSurvey, this.listQuestionFilterData, versionSelected.hash, nameVersionSelected);

     } else {
       this.translateAndIncludeSurvey(this.includeSurvey, this.listQuestionFilterData, null, nameVersionSelected);
     }
  }


  navigateToQuestionDetails(){
    this.router.navigate(['/surveys/new/' + this.surveyId]);
  }

  navigateToSmartAnalysis() {
    this.isShowExploreCompareChartsMode = false;
    this.activeTab = 2;
  }

  getSurveyLanguage(surveyId: number) {
    this.surveyService
      .getSurveyLanguage(surveyId)
      .subscribe(res => {
        this.surveyLanguages = res;
      }, err => {
      });
  }

  reloadData() {
    window.location.reload();
  }

  onChangeQuestionSetting(model: MasterSummaryPDModel): void {
    if (this.init) {
      const resultQuestions: SurveySettingQuestionModel[] = [];
      if (this.surveyUserSetting.settingsJSON.surveySettings.includeSurvey.compare) {
        for (let index = 0; index < model.listQuestionModel.length; index++) {
            if (model.listQuestionModel[index].id !== 0) {
                const surveySettingQuestionModel = new SurveySettingQuestionModel();
                surveySettingQuestionModel.questionNo = model.listQuestionModel[index].id;
                surveySettingQuestionModel.questionText = model.listQuestionModel[index].questionName;
                surveySettingQuestionModel.chartType = model.listQuestionModel[index].chartModeSelect;
                surveySettingQuestionModel.themeOn = model.listQuestionModel[index].themeModeSelect;

                if (this.surveyUserSetting.settingsJSON.surveySettings.includeSurvey.allResponsesSelected) {
                    const version = new SurveySettingVersionModel();
                    version.isAllResponses = true;
                    version.versionId = null;
                    version.cutId = null;
                    if (model.listQuestionModel[index].diffSortModeSelected == 'ALL RESPONSES') {
                        version.sort = model.listQuestionModel[index].sortModeSelect;
                    }
                    if (model.listQuestionModel[index].defaultChart.chart === 'AverageNumericResponse') {
                        if (model.listQuestionModel[index].diffPercentageSelectedAvgRes) {
                            version.typePercentageSelected = model.listQuestionModel[index].averageTypePercentageSelected;
                        }
                    } else {
                        if (model.listQuestionModel[index].diffPercentageSelected) {
                            version.typePercentageSelected = model.listQuestionModel[index].typePercentageSelected;
                        }
                    }
                    surveySettingQuestionModel.versions.push(version);
                }

                if (model.listSurveyVersionQuestion) {
                    model.listSurveyVersionQuestion.forEach(el => {
                        if (el.listQuestionModel[index]) {
                            const version = new SurveySettingVersionModel();
                            version.isAllResponses = false;
                            version.versionId = el.versionId;
                            version.cutId = null;
                            if (el.listQuestionModel[index].diffSortModeSelected == el.surveyName) {
                                version.sort = el.listQuestionModel[index].sortModeSelect;
                            }
                            if (el.listQuestionModel[index].defaultChart.chart === 'AverageNumericResponse') {
                                if (el.listQuestionModel[index].diffPercentageSelectedAvgRes) {
                                    version.typePercentageSelected = el.listQuestionModel[index].averageTypePercentageSelected;
                                }
                            } else {
                                if (el.listQuestionModel[index].diffPercentageSelected) {
                                    version.typePercentageSelected = el.listQuestionModel[index].typePercentageSelected;
                                }
                            }
                            surveySettingQuestionModel.versions.push(version);
                        }
                    })
                }

                if (model.listSurveyCutQuestion) {
                    model.listSurveyCutQuestion.forEach(el => {
                        if (el.listQuestionModel[index]) {
                            const version = new SurveySettingVersionModel();
                            version.isAllResponses = false;
                            version.versionId = null;
                            version.cutId = el.cutId;
                            if (el.listQuestionModel[index].diffSortModeSelected == el.surveyName) {
                                version.sort = el.listQuestionModel[index].sortModeSelect;
                            }
                            if (el.listQuestionModel[index].defaultChart.chart === 'AverageNumericResponse') {
                                if (el.listQuestionModel[index].diffPercentageSelectedAvgRes) {
                                    version.typePercentageSelected = el.listQuestionModel[index].averageTypePercentageSelected;
                                }
                            } else {
                                if (el.listQuestionModel[index].diffPercentageSelected) {
                                    version.typePercentageSelected = el.listQuestionModel[index].typePercentageSelected;
                                }
                            }
                            surveySettingQuestionModel.versions.push(version);
                        }
                    })
                }
                resultQuestions.push(surveySettingQuestionModel);
            }
        }
      } else {
        for (let index = 0; index < this.surveyMasterSummaryPDModel.listQuestionModel.length; index++) {
            if (this.surveyMasterSummaryPDModel.listQuestionModel[index].id !== 0) {
                const surveySettingQuestionModel = new SurveySettingQuestionModel();
                surveySettingQuestionModel.questionNo = this.surveyMasterSummaryPDModel.listQuestionModel[index].id;
                surveySettingQuestionModel.questionText = this.surveyMasterSummaryPDModel.listQuestionModel[index].questionName;
                const version = new SurveySettingVersionModel();
                version.isAllResponses = false;
                version.versionId = null;
                version.cutId = null;
                if (this.surveyMasterSummaryPDModel.listQuestionModel[index].id == model.listQuestionModel[0].id) {
                    surveySettingQuestionModel.chartType = model.listQuestionModel[0].chartModeSelect;
                    if (model.listQuestionModel[0].themeModeSelectChanged) {
                        surveySettingQuestionModel.themeOn = model.listQuestionModel[0].themeModeSelect != null ? model.listQuestionModel[0].themeModeSelect : null;
                    } else {
                        surveySettingQuestionModel.themeOn = model.listQuestionModel[0].themeModeSelect != null ? !model.listQuestionModel[0].themeModeSelect : null;
                    }
                    version.sort = model.listQuestionModel[0].sortModeSelect;
                } else {
                    surveySettingQuestionModel.chartType = this.surveyMasterSummaryPDModel.listQuestionModel[index].chartModeSelect || this.surveyMasterSummaryPDModel.listQuestionModel[index].defaultChart.chart;
                    surveySettingQuestionModel.themeOn = this.surveyMasterSummaryPDModel.listQuestionModel[index].themeModeSelect != null ? !this.surveyMasterSummaryPDModel.listQuestionModel[index].themeModeSelect : null;
                    version.sort = this.surveyMasterSummaryPDModel.listQuestionModel[index].sortModeSelect;
                }
                surveySettingQuestionModel.versions.push(version);
                resultQuestions.push(surveySettingQuestionModel);
            }
        }
      }

      this.surveyUserSetting.settingsJSON.surveySettings.questions = resultQuestions;
      if (this.cutId) {
        this.surveyService.updateSurveyUserSettingForCut(this.surveyUserSetting).subscribe(
            (response) => {
                if (response !== null) {
                    this.surveyUserSetting.settingsJSON.surveySettings.questions = response.settingsJSON.surveySettings.questions;
                }
            },
            (error) => {
            }
        );
      } else {
        this.surveyService.updateSurveyUserSetting(this.surveyUserSetting).subscribe(
            (response) => {
                this.surveyUserSetting = response;
            },
            (error) => {
            }
        );
      }
    }
  }

  changeTab(index): void {
    this.activeTab = index;
  }

  resetUserSetting() {
    this.surveyService.deleteSurveyUserSetting(this.surveyUserSetting).subscribe(
        (response) => {
            this.surveyService.resetSmartAnalysisResults();
            window.location.reload();
        },
        (error) => {
        }
    );
  }

  smartAnalysisChanged(surveySettingSmartAnalysisModel: SurveySettingSmartAnalysisModel) {
    this.surveyUserSetting.settingsJSON.surveySettings.smartAnalysis = surveySettingSmartAnalysisModel;
    this.surveyService.updateSurveyUserSetting(this.surveyUserSetting).subscribe(
        (response) => {
            this.surveyUserSetting = response;
        },
        (error) => {
        }
    );
  }

  onClickOutsideMenu(event: Object) {
    if (event && event['value'] === true) {
      this.showMenu = false;
    }
  }

  isShowExploreCompareCharts() {
    return this.includeSurvey.compare && this.activeTab == 1;
  }

  onShowExploreCompareChartsClick() {
    this.loader = true;
    setTimeout(() => {
        this.isShowExploreCompareChartsMode = !this.isShowExploreCompareChartsMode;
        this.loader = false;
    }, 100);
  }

  isHasCheckedQuestion() {
    return this.hideQuestions.filter(q => q.isUnhide).length ===0;
  }

  isDisabledExploreCompareCharts() {
    let count = 0;
    if (!isNullOrUndefined(this.surveyMasterSummaryPDModel)) {
        if (this.includeSurvey.allResponsesSelected) {
            count++;
        }
        if (this.surveyMasterSummaryPDModel.listSurveyVersionQuestion) {
            count += this.surveyMasterSummaryPDModel.listSurveyVersionQuestion.length;
        }
        if (this.surveyMasterSummaryPDModel.listSurveyCutQuestion) {
            count += this.surveyMasterSummaryPDModel.listSurveyCutQuestion.length;
        }
    }

    return count > 8;
  }
}




// WEBPACK FOOTER //
// ./src/app/routes/surveys/master-summary/master-summary.component.ts